<template>
  <v-dialog v-model="value" max-width="600">
    <v-card>
      <v-card-title class="headline grey lighten-2">
        Avaliações do Frentista
        <span v-if="frentista"> ({{frentista.nome }})</span>
      </v-card-title>

      <v-card-text>
        <div v-if="carregando" class="text-xs-center py-5">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
          <p class="mt-3">Carregando avaliações...</p>
        </div>

        <div v-else-if="avaliacoes && avaliacoes.length > 0">
          <v-list two-line>
            <template v-for="(avaliacao, index) in avaliacoes">
              <v-list-tile :key="avaliacao.id">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <v-layout align-center>
                      <span>Nota:</span>
                      <v-rating
                        :value="avaliacao.nota"
                        color="amber"
                        background-color="grey lighten-1"
                        dense
                        readonly
                        half-increments
                        size="18"
                        class="ml-2"
                      ></v-rating>
                      <span class="ml-2">({{ avaliacao.nota }})</span>
                    </v-layout>
                  </v-list-tile-title>

                  <v-list-tile-sub-title class="mt-2" style="white-space: pre-line;">
                    <strong>Comentário:</strong> {{ avaliacao.comentario }}
                  </v-list-tile-sub-title>

                  <v-list-tile-sub-title class="mt-1 caption">
                    Data: {{ formatarData(avaliacao.data_avaliacao) }} - Compra ID: {{ avaliacao.compra }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider v-if="index < avaliacoes.length - 1" :key="`divider-${avaliacao.id}`"></v-divider>
            </template>
          </v-list>
        </div>

        <div v-else class="text-xs-center py-4">
          Nenhuma avaliação encontrada para este frentista.
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="$emit('input', false)">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogAvaliacaoFrentista',
  props: {
    value: Boolean,
    avaliacoes: {
      type: Array,
      default: () => []
    },
    frentista: {
      type: Object,
      default: null
    },
    carregando: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatarData (data) {
      if (!data) return ''
      const d = new Date(data)
      const dia = String(d.getDate()).padStart(2, '0')
      const mes = String(d.getMonth() + 1).padStart(2, '0')
      const ano = d.getFullYear()
      const horas = String(d.getHours()).padStart(2, '0')
      const minutos = String(d.getMinutes()).padStart(2, '0')
      return `${dia}/${mes}/${ano} ${horas}:${minutos}`
    }
  },
  watch: {
    avaliacoes: {
      immediate: true,
      handler (newVal) {
        console.log('DialogAvaliacaoFrentista - Prop avaliacoes atualizada:', newVal, 'Length:', newVal ? newVal.length : 'N/A')
      }
    },
    carregando (newVal) {
      console.log('DialogAvaliacaoFrentista - Prop carregando atualizada:', newVal)
    }
  }
}
</script>
